import React from 'react';

import { Link } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import PaymentsIcon from '@mui/icons-material/Payments';

import AdvisorDashboardTile from './AdvisorDashboardTile';

import { useGetPayoutInfoQuery } from 'app/features/account/api/accountApi';
import { dateStamp } from 'app/helpers/timestampHelpers';
import { toCurrency } from 'app/helpers/currencyHelpers';

const AdvisorPayoutInfo = () => {
  const { data: payoutInfo, isLoading } = useGetPayoutInfoQuery();

  if (isLoading) return null;

  if (!payoutInfo?.paymentRequest?.id) {
    return (
      <AdvisorDashboardTile
        title="Payout Info"
        icon={<PaymentsIcon sx={{ color: '#888' }} />}
        manageHref="/account/payout"
      >
        <Box sx={{ textAlign: 'center', mt: 2 }}>
          <Typography variant="h3">
            Payout not setup
          </Typography>

          <Typography variant="h5">
            Setup payouts to receive your earnings
          </Typography>
          <br />
          <Link to="/account/payout">
            <Button variant="contained" size="medium">Setup</Button>
          </Link>
        </Box>
      </AdvisorDashboardTile>
    );
  }

  return (
    <AdvisorDashboardTile
      title="Payout Info"
      icon={<PaymentsIcon sx={{ color: '#888' }} />}
      manageLink="/account/payout"
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'auto auto',
          justifyItems: 'start',
          gap: 1,
          my: 4,
        }}
      >
        <Typography>Payout Set</Typography>
        <Typography>{payoutInfo.payment_request?.payment_type_and_period_label}</Typography>

        <Typography>Last Payout</Typography>
        <Typography>{toCurrency(payoutInfo.transfer?.amount)}</Typography>

        <Typography>Last Payout Date</Typography>
        <Typography>{dateStamp(payoutInfo.transfer?.created_at)}</Typography>
      </Box>

      <Box sx={{ textAlign: 'center', mt: 2 }}>
        <Link to="/transactions/details" style={{ textDecoration: 'none' }}>
          View Transactions
        </Link>
      </Box>
    </AdvisorDashboardTile>
  );
};

export default AdvisorPayoutInfo;
